import traceUFOPress from '@atlassian/react-ufo/trace-press';

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'model/State';

import { MACLicensesPage } from './LicensesPage';
import {
  fetchIsHostedAccountProvisioning,
  fetchIsOnBehalfOfEmail,
  fetchIsSiteOnConcession,
  fetchTrackedElsewhere,
} from './duck/actions/accountId';
import {
  fetchDetails,
  fetchIsRenewableAccount,
  fetchIsUpgradableAccount,
} from './duck/actions/accounts';
import { getCurrentMACContactEmail, selectDetails } from './duck/selectors';
import { fetchGenericProperty } from './duck/actions/genericProperty';
import { LICENSE_DETAILS_UFO_NAME } from 'util/ufoNameConstants';

const MACLicensesPreselectedPage = () => {
  const dispatch = useDispatch();
  const sen = useSelector((state: State) => state.location.payload.senNumber);
  const currentContactEmail = useSelector(getCurrentMACContactEmail);
  const accountDetails: any = useSelector((state: State) => selectDetails(state, sen));

  let genericPropertyFullKey = '';
  useEffect(() => {
    if (accountDetails) {
      const productPackage =
        accountDetails.merchandise?.productPackage || accountDetails.productPackage;
      genericPropertyFullKey =
        productPackage?.downloadProduct?.key &&
        `related.source.product.${productPackage.downloadProduct.key}`;
    }
  }, [accountDetails]);

  useEffect(() => {
    if (currentContactEmail) {
      traceUFOPress(LICENSE_DETAILS_UFO_NAME);
      dispatch(fetchDetails(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchTrackedElsewhere(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchIsSiteOnConcession(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchIsRenewableAccount(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchIsUpgradableAccount(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchIsOnBehalfOfEmail(sen, LICENSE_DETAILS_UFO_NAME));
      dispatch(fetchIsHostedAccountProvisioning(sen, LICENSE_DETAILS_UFO_NAME));
    }
  }, [currentContactEmail]);

  useEffect(() => {
    if (genericPropertyFullKey) {
      dispatch(fetchGenericProperty(genericPropertyFullKey));
    }
  }, [genericPropertyFullKey]);

  return <MACLicensesPage senNumber={sen} />;
};

export default MACLicensesPreselectedPage;
